import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import VisibilitySensor from 'react-visibility-sensor';

import { PAYPAL_BUTTON_IMPRESSION, PAYPAL_BUTTON_CLICK } from 'lib/analytics/events';

const propTypes = {
  handlePaypalCancel: PropTypes.func,
  card: PropTypes.string,
  isPaypal: PropTypes.bool,
  paypalEmail: PropTypes.string,
  showPaypal: PropTypes.bool,
  trackEvent: PropTypes.func.isRequired,
};

const defaultProps = {
  card: null,
  isPaypal: false,
  paypalEmail: null,
  showPaypal: true,
  handlePaypalCancel: () => {},
};

class PaypalBar extends Component {
  constructor(props) {
    super(props);

    this.handlePayPalVisibilityChange = this.handlePayPalVisibilityChange.bind(this);
    this.onPayPalClick = this.onPayPalClick.bind(this);
  }

  handlePayPalVisibilityChange(visible) {
    if (visible) {
      this.props.trackEvent(PAYPAL_BUTTON_IMPRESSION);
    }
  }

  onPayPalClick() {
    this.props.trackEvent(PAYPAL_BUTTON_CLICK);
  }

  renderCreditCardImage() {
    const ccClass = this.props.card ? `cc-type-${this.props.card}` : '';

    if (this.props && !this.props.isPaypal) {
      return (
        <div className="col-md-6 non-paypal">
          <div className="form-group">
            <span id="cc-types" className={`cc-cards-accepted  ${ccClass}`}>
              <FormattedMessage
                id="checkout.cards-accepted"
                defaultMessage="Payment Cards Accepted"
              />
            </span>
          </div>
        </div>
      );
    }
    return null;
  }

  renderPaypalButton() {
    if (!this.props.showPaypal) { return null; }
    return (
      <div className="col-md-6 text-align-md-right">
        <VisibilitySensor onChange={this.handlePayPalVisibilityChange}>
          <div className="form-group">
            <button id="paypal-button" tabIndex="-1" onClick={this.onPayPalClick} />
          </div>
        </VisibilitySensor>
      </div>
    );
  }

  render() {
    if (this.props.isPaypal) {
      return (
        <div className="row">
          <div className="col-md-10">
            <div id="braintree-paypal-loggedin">
              <span id="bt-pp-name">PayPal</span>
              <span id="bt-pp-email">
                {this.props.paypalEmail}
              </span>
              <button id="bt-pp-cancel" onClick={this.props.handlePaypalCancel}>
                <FormattedMessage id="checkout.cancel" defaultMessage="Cancel" />
              </button>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className="row">
        {this.renderCreditCardImage()}
        {this.renderPaypalButton()}
      </div>
    );
  }
}

PaypalBar.propTypes = propTypes;
PaypalBar.defaultProps = defaultProps;

export default PaypalBar;
